import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? 'md:flex-col md:items-center md:text-center' : ''
      }`}
    >
      <div className={isCenter ? 'max-w-2xl' : ''}>
        <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-primary-600">
          <span className="h-px w-6 bg-primary-500" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}